export default __webpack_public_path__ + "static/media/showcase.948c8d09.mp4";